import React, {useContext, useEffect, useState} from "react";
import { mockPieData } from '../../data/mockData';
import '../../../styles/chart.css';
import {ViewContext} from "../../Context/ViewContext";
import { Label } from "semantic-ui-react";


export const BasicIndicator = ({ data, dataBis, title, content1, content2, content3, content4, contentSize, locked}) => {
    const { view } = useContext(ViewContext)
    if(typeof contentSize === 'undefined') {
        contentSize = (view == "simple") ? '40px' : '17px';
    }

    title = title || data?.title;
    
    //à supprimer quand tt les BasicIndicator seront formatés
    content1 = data?.content1 || content1;
    content2 = data?.content2 || content2;
    content3 = data?.content3 || content3;
    content4 = data?.content4 || content4;
    const label = data?.label

    const {content1Second, content2Second, content3Second, content4Second, labelSecond} = dataBis || {};

    return (
        <div className={`basicIndicatorContainer ${title === 'CA recherche en cours' ? 'lastIndic' : ''}`} style={{display: 'flex', flexDirection: 'column', alignContent: 'center', backgroundColor: locked ? '#d5d5d5' : 'white'}}>
            <div>
                <p className="titleN text-center">{title}</p>
                <div style={{ display: 'flex', justifyContent: 'center'}}>
                    <div style={{display: 'inline-block'}}>
                        <p style={{display: (view == "simple") ? 'none' : 'block'}}>{label}</p>
                        <p className="numberN" style={{fontSize: contentSize}}>{content1}</p>
                        <p
                            style={{textAlign: 'center', fontSize: (view == "simple") ? '30px' : ''}}>
                            <span className="numberNvar">{content2}</span>
                        </p>
                        <p className="titleN1">{content3}</p>
                        <p className="numberN1" style={{fontSize: contentSize}}>{content4}</p>
                    </div>
                    <div style={{display: (view == "simple") ? 'none' : 'inline-block', marginLeft: '35px'}}>
                        <p>{labelSecond}</p>
                        <p className="numberN" style={{fontSize: contentSize}}>{content1Second}</p>
                        <p style={{textAlign: 'center'}}><span className="numberNvar">{content2Second}</span></p>
                        <p className="titleN1">{content3Second}</p>
                        <p className="numberN1" style={{fontSize: contentSize}}>{content4Second}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}



